/*
  Automatically instantiates modules based on data-attributes
  specifying module file-names.
*/

const moduleElements = document.querySelectorAll('[data-module]')

for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i]
  const name = el.getAttribute('data-module')
  const Module = require(`./${name}`).default
  new Module(el)
}



/*
  Usage:
  ======

  html
  ----
  <button data-module="disappear">disappear!</button>

  js
  --
  // modules/disappear.js
  export default class Disappear {
    constructor(el) {
      el.style.display = none
    }
  }



# Examples:

import fieldFormats from './modules/fieldFormats';
fieldFormats();


## Simple function export example:
import {smooth} from './modules/example-simple-function-export.js'

## Export default function: 
import smooth from './modules/smoothScroll';

## Require an entire file:





import fieldFormats from './modules/fieldFormats';
fieldFormats();


# Examples:

## Simple function export example:
import {smooth} from './modules/example-simple-function-export.js'

## Export default function: 
import smooth from './modules/smoothScroll';

## Require an entire file:


*/



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js